import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color, Typography } from '@figure/frontlib-gui';

const LI = styled.li`
  margin-bottom: 15px;

  &:before {
    content: '';
    background-color: ${({ color }) => color || Color.LIGHT_GREY};
    display: inline-block;
    position: absolute;
    margin-left: -1.5rem;
    margin-top: 0.5rem;
    font-size: 1.5rem;
    border-radius: 50%;
    width: 8px;
    height: 8px;
  }
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;

  > * {
    margin: 0;
  }
`;

const Dotted = styled.div`
  font-size: 2rem;
  border-bottom: 1px dotted ${Color.DARK_GREY};
  flex-grow: 2;
  margin-right: 10px;
  position: relative;
  bottom: 5px;
`;

const IncomeListItem = ({ category, completed, errored, children }) => {
  let color;
  if (completed) color = Color.TEAL;
  if (errored) color = Color.MELLOW_YELLOW;

  return (
    <LI color={color}>
      <Inner>
        <Typography.SmallBody>{category}</Typography.SmallBody>
        {!errored ? <Dotted /> : null}
        {children}
      </Inner>
    </LI>
  );
};

IncomeListItem.propTypes = {
  category: PropTypes.node.isRequired,
  completed: PropTypes.bool,
  errored: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

IncomeListItem.defaultProps = {
  completed: false,
  errored: false,
};

export default IncomeListItem;
